const urlName = '/monitor/v1/ai'


export default API => ({
    postcamera({ params, data }) {
        return API({ url: `monitor/v1/humanFace/comparison`, method:'post', params, data,isToast:false });
    },
    judgefaceauth({ params, data }) {
        return API({ url: `/monitor/v1/user/oauth/isRealNameAuthentication`, method:'post', params, data });
    },
})